module.exports = __webpack_public_path__ + "static/img/bg-card-orange.cf41134.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/game/bg-card-orange.jpg
// module id = 741
// module chunks = 2 3 4 5 12